// extracted by mini-css-extract-plugin
export var box = "AboutTheCourse-module--box--eeddc";
export var box_md = "AboutTheCourse-module--box_md--09f27";
export var box_xmd = "AboutTheCourse-module--box_xmd--c33a7";
export var box_flex = "AboutTheCourse-module--box_flex--96203";
export var box_lg = "AboutTheCourse-module--box_lg--b7586";
export var box_sm = "AboutTheCourse-module--box_sm--6f9c2";
export var box_outer = "AboutTheCourse-module--box_outer--68b53";
export var box_whiteBg = "AboutTheCourse-module--box_white-bg--22806";
export var box_noMarginBottom = "AboutTheCourse-module--box_no-margin-bottom--943a3";
export var box_noPadding = "AboutTheCourse-module--box_no-padding--cdf31";
export var box_outerGray = "AboutTheCourse-module--box_outer-gray--1f5ff";
export var box_dark = "AboutTheCourse-module--box_dark--494f8";
export var box_zIndex = "AboutTheCourse-module--box_z-index--24400";
export var box_zIndex6 = "AboutTheCourse-module--box_z-index-6--f3096";
export var box_eventsWithLine = "AboutTheCourse-module--box_events-with-line--2048f";
export var box_featuresAo = "AboutTheCourse-module--box_features-ao--c004e";
export var box_verticalPaddings = "AboutTheCourse-module--box_vertical-paddings--f60e4";
export var clearP = "AboutTheCourse-module--clearP--6aa73";
export var clearP_vc = "AboutTheCourse-module--clearP_vc--d4ad2";
export var layout = "AboutTheCourse-module--layout--c6122";
export var cards = "AboutTheCourse-module--cards--6a938";
export var name = "AboutTheCourse-module--name--b2bf4";
export var value = "AboutTheCourse-module--value--47490";
export var fadeInAnimation = "AboutTheCourse-module--fadeInAnimation--de74d";
export var placeHolderShimmer = "AboutTheCourse-module--placeHolderShimmer--f5aeb";